package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_chart

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.IdUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.DashboardDialogs
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_chart.component.DashboardGeneralInfo
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_chart.component.chart.DashboardChart
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi.DashboardEvent
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi.DashboardState
import org.jetbrains.compose.web.css.Position

@Composable
fun DashboardCharts(
    state: DashboardState,
    event:(DashboardEvent)->Unit,
    windowSizeMode: WindowSizeModeEnum,
)
{
    Column(
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Relative)
            .padding(
                topBottom = Dimen.normalPadding,
            )
            .onClick {
                event(DashboardEvent.OnBackGroundClick)
            }
    ){
        DashboardGeneralInfo(
            windowSizeMode = windowSizeMode,
            cashRegistersCount=state.listShop?.filter {
                    it?.id == state.selectedDashboardItem?.branchId.toString()
                }?.flatMap { it?.cashRegisters.orEmpty()}?.size,
            currencyType=state.currencyType?:"",
            dashboardItem=state.selectedDashboardItem,
            selectedDate = state.selectedDate,
            dashboardItemName =state.dashboardItemName?:"",
            onBackClick={
                event(DashboardEvent.OnDetailBackClick)
            },
            setCalendarStatus = {
                event(DashboardEvent.SetCalendarStatus(it))
            }
        )

        Column(
            modifier = VerticalScrollBehavior.toModifier()
                .fillMaxWidth()
                .showContentInOnePage()
        )
        {
            DashboardChart(
                windowSizeMode=windowSizeMode,
                mainData=state.customerFrequencies?.map { it?.billCount },
                comparedData = state.comparedClientsCustomerFrequencies,
                interval=state.customerFrequencies?.map { it?.interval },
                selectedDate = state.selectedDate,
                comparedDate = state.clientCompareDate,
                title = Strings.current().clients,
                id =IdUtils.clientChartId ,
                firstStrokeColor = Theme.PrimaryMain.hex ,
                firstFillColor =Theme.PrimaryStatesFocus.hex ,
                secondStrokeColor = Theme.WarningMain.hex,
                secondFillColor =Theme.WarningStatesSelected.hex ,
                showCompareChartDialogStatus = state.showCompareClientChartDialog,
                todayCircleColor =Theme.PrimaryMain.rgb ,
                comparedCircleColor = Theme.WarningMain.rgb,
                showCompareChartDialog = {
                    event(DashboardEvent.SetCompareClientChartDialogStatus(
                        status = !state.showCompareClientChartDialog
                    ))
                },
                onCompareDayClick = {
                    event(DashboardEvent.GetOtherDaysCustomerClientsFrequency(it))
                }
            )

            DashboardChart(
                mainData = state.customerFrequencies?.map { it?.total },
                comparedData = state.comparedSalesCustomerFrequencies,
                title = Strings.current().sales,
                id =IdUtils.salesChartId,
                firstFillColor =Theme.SuccessSelected.hex,
                firstStrokeColor = Theme.SuccessMain.hex,
                secondFillColor =Theme.WarningStatesSelected.hex,
                secondStrokeColor = Theme.WarningMain.hex,
                interval=state.customerFrequencies?.map { it?.interval },
                selectedDate = state.selectedDate,
                comparedDate = state.saleCompareDate,
                showCompareChartDialogStatus = state.showCompareSaleChartDialog,
                todayCircleColor = Theme.SuccessMain.rgb,
                comparedCircleColor =Theme.WarningMain.rgb,
                windowSizeMode = windowSizeMode,
                showCompareChartDialog = {
                    event(DashboardEvent.SetCompareSaleChartDialogStatus(
                        status = !state.showCompareSaleChartDialog
                    ))
                },
                onCompareDayClick = {
                    event(DashboardEvent.GetOtherDaysCustomerSalesFrequency(it))
                },
            )
        }




    }

    DashboardDialogs(
        showCalendarDialog = state.showCalendarDialog,
        selectedDate=state.selectedDate,
        calendarData = state.calendarData,
        onSelectDay = {
            event(DashboardEvent.GetCustomerFrequency(it))
        },
        onBackgroundClick = {
            event(DashboardEvent.SetCalendarStatus(false))
        },
        closeCalendarDialog = {
            event(DashboardEvent.SetCalendarStatus(false))
        }
    )


}